import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslocoModule } from "@jsverse/transloco";
import { ButtonModule } from "../button/button.module";
import { ContainerModule } from "../container/container-module";
import { AttachmentsComponent } from "src/app/components/ui/attachments/attachments.component";
import { DirectivesModule } from "src/app/modules/bootstrap/directives/directives.module";
import { DropzoneModule } from "src/app/components/ui/dropzone/dropzone.module";

@NgModule({
  imports: [
    CommonModule,
    TranslocoModule,
    DirectivesModule,
    ContainerModule,
    ButtonModule,
    DropzoneModule
  ],
  declarations: [AttachmentsComponent],
  exports: [AttachmentsComponent]
})
export class AttachmentsModule {}
